import MenuBookIcon from '@mui/icons-material/MenuBook';
import Button from '@mui/material-next/Button';

export default function BotaoOrientacoes() {
    return (
            <>
                <Button variant="text" sx={{ fontFamily: 'sans-serif' }} href="https://www.cnm.org.br/storage/noticias/2023/Links/XXV%20Marcha/XXV-Marcha-2024-orienta%C3%A7%C3%B5es.docx" target="_blank">
                    <MenuBookIcon /> Orientações Gerais
                </Button>
            </>
    );
}
